import { HTMLAttributes } from "react";
import { cn } from "./cn";

type TypographyProps = HTMLAttributes<HTMLHeadingElement> & {
  children: React.ReactNode;
  className?: string;
};

export const H1 = ({ children, className, ...props }: TypographyProps) => (
  <h1
    className={cn("font-unbounded text-2xl lg:text-5xl", className)}
    {...props}
  >
    {children}
  </h1>
);
export const H2 = ({ children, className, ...props }: TypographyProps) => (
  <h1
    className={cn("font-unbounded text-[16px] sm:text-[18px] leading-[24px] sm:leading-[27px] font-normal  ", className)}
    {...props}
  >
    {children}
  </h1>
);
export const Primary_P = ({
  children,
  className,
  ...props
}: TypographyProps) => (
  <p className={cn("text-xs lg:text-sm text-gray-40", className)} {...props}>
    {children}
  </p>
);
